const knowledgexApiBase =
	process.env.REACT_APP_KNOWLEDGEX_API_URL || "http://localhost:8002";

export const API_GATEWAY_URL =
	process.env.REACT_APP_API_GATEWAY_URL ||
	"https://intelligentx-apigateway.azure-api.net";

export const KNOWLEDGEX_OCR_URL = `${knowledgexApiBase}/knowledgex/ocr`;
export const KNOWLEDGEX_SUMMARIZE_URL = `${knowledgexApiBase}/knowledgex/ocr/summarize`;
export const KNOWLEDGEX_OCR_ASK_URL = `${knowledgexApiBase}/knowledgex/ocr/ask`;

export const SCHEDULERX_API_BASE =
	process.env.REACT_APP_SCHEDULERX_API_URL || "http://localhost:8003";

export const SCHEDULERX_HEALTH_SUMMARY_URL = `${SCHEDULERX_API_BASE}/scheduler/health-summary`;
export const SCHEDULERX_HEALTH_ACTION_ITEMS_URL = `${SCHEDULERX_API_BASE}/scheduler/health-action-items`;
export const SCHEDULERX_ANALYZE_MEDICAL_URL = `${SCHEDULERX_API_BASE}/scheduler/analyze-medical`;
export const SCHEDULERX_MANUFACTURING_SUMMARY_URL = `${SCHEDULERX_API_BASE}/scheduler/manufacturing-summary`;
export const SCHEDULERX_SEND_MEETING_EMAIL_URL = `${SCHEDULERX_API_BASE}/scheduler/send-meeting-email`;
export const SCHEDULERX_ASK_URL = `${SCHEDULERX_API_BASE}/scheduler/ask-scheduler`;

export const SCHEDULERX_AGENT_ID =
	process.env.REACT_APP_SCHEDULERX_AGENT_ID || "07843a96-cfbb-403c-9cac-40f8f16c3969";
export const SCHEDULERX_CREATED_BY =
	process.env.REACT_APP_SCHEDULERX_CREATED_BY || "844781ce-6675-488f-bf29-432a5c7b7019";

export const AZURE_SPEECH_KEY = process.env.REACT_APP_AZURE_SPEECH_KEY || "";
export const AZURE_SPEECH_REGION = process.env.REACT_APP_AZURE_SPEECH_REGION || "eastus";

export const ONBOARDING_DEFAULT_PROJECT_ID =
	process.env.REACT_APP_ONBOARDING_PROJECT_ID || "";
export const ONBOARDING_DEFAULT_ORG_ID =
	process.env.REACT_APP_ONBOARDING_ORG_ID || "";
export const ONBOARDING_DEFAULT_EMAIL =
	process.env.REACT_APP_ONBOARDING_EMAIL || "";
